module.exports = "<p>\n  content-area works!\n</p>\n"